export const PHONE_CODES_LOADING = "phoneCodes/LOADING";
export const PHONE_CODES_ERROR = "phoneCodes/ERROR";

export const PHONE_CODES_LIST = "phoneCodes/LIST";
export const PHONE_CODES_FILTERS = "phoneCodes/FILTERS";
export const PHONE_CODES_CREATE = "phoneCodes/CREATE";
export const PHONE_CODES_UPDATE = "phoneCodes/UPDATE";
export const PHONE_CODES_DELETE = "phoneCodes/DELETE";



// WEBPACK FOOTER //
// ./src/actions/phone-codes/constants.js